<template>
  <div id="app" class="height100" v-cloak>
    <router-view></router-view>
    <!--<progress class="app progressXQ" max="100" value="0" id="progressXQ"></progress>-->
    <!--<div class="el-loading-spinner" id="loadingXQ" style="display: none;z-index: 9999"><img src="../static/image/loading.gif" alt="正在加载..."></div>-->
    <!--<div class="el-loading-spinner" id="loadingLY" style="display: none;z-index: 9999"><img src="../static/image/loading.gif" alt="正在加载..."></div>-->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue